import { combineReducers } from 'redux';
import enrollClientsReducer from './enroll_clients_reducer';
import recommendGomotiveReducer from './recommend_gomotive_reducer';


export default combineReducers({
    enrollClientsReducer,
    recommendGomotiveReducer,
});